var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.25,
    height: 11.75,
    fill: "none",
    viewBox: "0 0 15.25 11.75"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD166",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "m1.125 6.125 4.5 4.5 8.5-9.5"
  })));
};
export default SvgCheck;